import { takeEvery, put, select } from "redux-saga/effects";
import * as actionTypes from "../types/types";
import { decreaseLives, gameOver, gameWon, togglePauseMessage  } from "../actions/actions";
import { Bullet } from "../../game_entities/Bullet/Bullet";
import { gameConstants } from "../../helpers/helper_object";

function* movePlayerSaga(action) {
  const { game } = yield select();
  const { player, time } = action.payload;

  if (!game) return;

  switch (action.type) {
    case actionTypes.MOVE_PLAYER_LEFT:
      player.x -= player.velocity * time;
      break;
    case actionTypes.MOVE_PLAYER_RIGHT:
      player.x += player.velocity * time;
      break;
    case actionTypes.MOVE_PLAYER_UP:
      player.y -= player.velocity * time;
      break;
    case actionTypes.MOVE_PLAYER_DOWN:
      player.y += player.velocity * time;
      break;
    default:
      break;
  }
}

function* shootSaga(action) {
  const { game } = yield select();
  const { player } = action.payload;
  const currentTime = new Date().getTime();
  const elapsedTime = currentTime - player.lastShotTime;

  if (elapsedTime > player.shootCoolDown) {
    const bullet = new Bullet(
      player.x + player.width / 2,
      player.y + player.height / 2,
      game
    );
    bullet.velocityY = -0.4;
    player.bullets.push(bullet);
    player.lastShotTime = currentTime;
  }
}

function* checkCollisionSaga(action) {
  if (!action.payload) return;

  const { player, enemy, entrance, currGame } = action.payload;
  const { COLLISION_MARGIN, ENTRANCE_COLLISION_THRESHOLD } = gameConstants;

  const checkCollision = (rect1, rect2) =>
    rect1.x < rect2.x + rect2.width - COLLISION_MARGIN &&
    rect1.x + rect1.width - COLLISION_MARGIN > rect2.x &&
    rect1.y < rect2.y + rect2.height - COLLISION_MARGIN &&
    rect1.y + rect1.height - COLLISION_MARGIN > rect2.y;

  if (
    action.type === actionTypes.CHECK_COLLISION &&
    checkCollision(player, enemy)
  ) {
    currGame.gameOver = true;
    yield put(decreaseLives(0));
    yield put(gameOver({ outcome: "Enemy Collision" }));
  } else if (action.type === actionTypes.CHECK_ENTRANCE_COLLISION) {
    const { x, y, width, height } = entrance;
    const dx = Math.abs(player.x + player.width / 2 - (x + width / 2));
    const dy = Math.abs(player.y + player.height / 2 - (y + height / 2));

    if (
      dx < player.width / 2 + width / ENTRANCE_COLLISION_THRESHOLD &&
      dy < player.height / 2 + height / ENTRANCE_COLLISION_THRESHOLD
    ) {
      currGame.gameOver = true;
      const remainingCrew =
        currGame.remainingLives === 5
          ? `Entire crew survived. You Are Top Gun!`
          : `${currGame.remainingLives} Members of Crew Survived`;
      yield put(gameWon());
      yield put(
        gameOver({
          destroyedEnemies: `${currGame.score} Enemy Ships Destroyed`,
          crew: `${remainingCrew}`,
        })
      );
    }
  }
}

function* checkEnemyPastBottomSaga(action) {
  if (action.payload) {
    const { enemy, height, currGame } = action.payload;

    if (enemy && enemy.y > height) {
      currGame.gameOver = true;
      yield put(gameOver({ outcome: "Enemy Passed Perimeter" }));
    }
  }
}

function* gameTimeoutSaga() {
    const { game } = yield select();
    game.savedGameState.gameState.gameOver = true;
    yield put(gameOver({outcome: "Timeout"}));
}

function* pauseGameSaga() {
  const { game } = yield select();

  if (!game.savedGameState.gameState.isPaused) {
    game.savedGameState.gameState.isPaused = true;
    yield put(togglePauseMessage({message:"Resume"}))
  } else {
    game.savedGameState.gameState.isPaused = false;
    yield put(togglePauseMessage({message:"Pause"}))
  }
}

export function* watchGameActionsSaga() {
  yield takeEvery(
    [actionTypes.CHECK_COLLISION, actionTypes.CHECK_ENTRANCE_COLLISION],
    checkCollisionSaga
  );
  yield takeEvery(
    [
      actionTypes.MOVE_PLAYER_LEFT,
      actionTypes.MOVE_PLAYER_RIGHT,
      actionTypes.MOVE_PLAYER_UP,
      actionTypes.MOVE_PLAYER_DOWN,
    ],
    movePlayerSaga
  );
  yield takeEvery(actionTypes.SHOOT, shootSaga);
  yield takeEvery(
    actionTypes.CHECK_ENEMY_PAST_BOTTOM,
    checkEnemyPastBottomSaga
  );
  yield takeEvery(actionTypes.PAUSE_GAME, pauseGameSaga);
  yield takeEvery(actionTypes.GAME_TIMEOUT, gameTimeoutSaga);
}
